import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/font.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './scss/hitachi.scss';
import './index.css';
import App from './App';
import Feature from './page/Feature';
import Placement from './page/Placement';
import Model from './page/Model';
import Attention from './page/Attention';
import Finish from './page/Result';
import Home from './page/Home';
import Share from './page/Share';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter,Routes,Route} from 'react-router-dom';
import "./i18n"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import TagManager from 'react-gtm-module';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const tagManagerArgs = {
  gtmId: 'GTM-TNC3GJ5'
}
const tagManagerArgsHitachi = {
  gtmId: 'GTM-KNJHJV5'
}
TagManager.initialize(tagManagerArgsHitachi)
TagManager.initialize(tagManagerArgs)
root.render(
  <BrowserRouter basename="/ae/ar/choose-your-refrigerator">
    <Routes>
      <Route  path="/" element={<Home/>}/>
      <Route  path="/capacity" element={<App/>}/>
      <Route  path="/feature" element={<Feature/>}/>
      <Route  path="/placement" element={<Placement/>}/>
      <Route path="/models" element={<Model/>}/>
      <Route path="/attention" element={<Attention/>}/>
      <Route path="/finish" element={<Finish/>}/>
      <Route path="/share/:style/:code/:color" element={<Share/>}/>
  </Routes>
</BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
